<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader v-if="nominationType === 'received'" name="Nomination Received"></ContentHeader>
        <ContentHeader v-else name="Nomination Sent"></ContentHeader>
        <div class="pt-2 mb-3" v-if="this.nomination.isteamaward[0] !== undefined && this.nomination.isteamaward[0] == 'true'">
          <h4 class="text-black-50" v-if="nominationType === 'received'">You've received a {{ nominationCategory }} Nomination: </h4>
          <h4 class="text-black-50" v-else>You've sent a {{ nominationCategory }} to: </h4>
          <BR/>
          <h5>Nominated Team Members:</h5>
          <ul>
            <li v-for="(option, index) in ['MCGEOYOption1','MCGEOYOption2','MCGEOYOption3']" :key="option">
              <h6><i class="fas fa-user fa-fw"></i> Selection: Option {{ index+1 }}</h6>
              <h6 v-if="getMatch(nomination[option][0].email, 'member_name')">
                <i class="fas fa-check fa-fw"></i> Name:
                {{ getMatch(nomination[option][0].email, 'member_name') }}
              </h6>
              <h6 v-if="getMatch(nomination[option][0].email, 'member_employee_number')">
                <i class="fas fa-check fa-fw"></i> Employee Number:
                {{ getMatch(nomination[option][0].email, 'member_employee_number') }}
              </h6>
              <h6><i class="fas fa-check fa-fw"></i> GOM: {{ nomination[option][0].GOM }}</h6>
            </li>
          </ul>
        </div>
        <div class="pt-2 mb-3" v-else>
          <h4 class="text-black-50" v-if="nominationType === 'received'">You've received a {{ nominationCategory }} Nomination: </h4>
          <h4 class="text-black-50" v-else>You've sent a {{ nominationCategory }} to: </h4>
          <BR/>
          <h5>Nominee Details:</h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination.nominee_name[0]}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Employee Number :</span> {{ nomination.nominee_employeeNumber[0] }}</h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominee_company[0]}}</h6>
        </div>
        <hr>
        <h5>Nominator Details:</h5>
        <div class="pt-2 mb-3">
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination._embedded.author[0].name}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominator_details[0][0]['employee-company']}}</h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <router-link :to="'/mcg-employee-award-year/'" target="_blank" class="btn btn-primary mb-3 text-white">Back to MCG Nomination Form</router-link><br>
        <hr>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import FieldFileInput from '@/components/FieldFileInput'
import Field150Word from '@/components/Field150Word'
import FieldTagAdd from '@/components/FieldTagAdd'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    FieldFileInput,
    Field150Word,
    FieldTagAdd
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      nomination: {},
      currentUserProfile: {},
      nominationCategory: '',
      showSubstationFields: true,
      acceptDeclineMsg: '',
      nominatedComments: '',
      nominatedSupportingDoc: '',
      nominatedReferences: '',
      termsCheckbox: false,
      termsNotAccepted: false,
      nominationAccepted: false,
      nominationDeclineReason: '',
      userSubmittedCompany: '',
      otherReason: '',
      showOtherReason: false,
      currentTeamMemberStatus: false,
      promoteStage: '',
      nominationDate: '',
      award: [],
      nominationType: '',
      addedDocument: [],
      url: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    var self = this
    console.log(this.getProfileDetails)
    document.title = this.$route.name + ' - ThinkTank'
    self.nominationType = self.$route.params.type
    console.log(' self.type ', self.nominationType)
    var usernameOptions = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('userToken'),
        'Content-Type': 'application/json'
      },
      json: true
    }
    WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
      .then(function (userResponse) {
        self.currentUserProfile = userResponse.data

        WordpressRestAPI.getViewContent('nomination/' + self.$route.params.id + '?_embed')
          .then(response => {
            self.nomination = response.data
            console.log(' self.nomination ', self.nomination)
            self.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
            self.contentReady = true
            self.getDate()
            self.nominationAccepted = response.data.nomination_approve_decline[0] !== 'Pending'
            console.log(' nominationCategory ', self.nominationCategory, self.nomination.AddedDocumentID, self.nomination.supporting_documentation)
            if (self.nomination.isteamaward[0] === 'true') {
              self.currentTeamMemberStatus = self.nomination.nominationteam[0].filter(d => d.member_slug === self.currentUserProfile.slug)
              if (self.currentTeamMemberStatus.length > 0) {
                self.nominationAccepted = (self.currentTeamMemberStatus[0].member_approve_reject !== 'Pending')
              }
              var categorySlug = response.data.slug.split('-by')[0] // TODO: FIND A VALID SLUG
              WordpressRestAPI.getViewContent('nomination_event?slug=' + categorySlug + '&_embed')
              .then(response => {
                self.award = response.data[0]
              })
              .catch(e => {
                console.error(e)
              })
            }
          })
          .catch(e => {
            self.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
            console.error(e)
          })
      })
      .catch(function (error) {
        console.error(error)
      })
  },
  methods: {
    getMatch: function (email, type) {
      for (var i = 0; i < this.nomination.nominationteam[0].length; i++) {
        if (this.nomination.nominationteam[0][i].member_email == email) {
          console.log('getMatch match ', i, this.nomination.nominationteam[0][i], email)
          if (type == 'member_name') {
            return this.nomination.nominationteam[0][i].member_name
          }
          if (type == 'member_employee_number') {
            return this.nomination.nominationteam[0][i].member_employee_number
          }
        }
      }
      return null; // no match
    },
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
  },
  watch: {
    immediate: true,
    deep: true,
    getProfileDetails (newDetails, oldDetails) {
      if (this.getProfileDetails.name !== this.nomination.nominee_name[0]) {
        this.$router.push('/')
      }
    }
  }
}
</script>
<style scoped>
a {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/routes/NominationMCGReview.vue